<template>
  <div id="centerDiv" class="trajectory-map" style="position: relative">
    <mars-map
      :url="configUrl"
      @onload="onMapload"
      :options="myOptions"
      style="width: 100; height: 100%"
    />
  </div>
</template>

<script>
import MarsMap from "./Map.vue"
let Map = null // 全局地图
let roamLine;
let roamLineData = {};
let mars3d;
let eventTarget;
const basePathUrl = window.basePathUrl || ""
export default {
	components: {
		MarsMap
	},
	data() {
		return {
			configUrl: basePathUrl + "config/config.json",
			myOptions: {},
			map: {},
			sindex: 0
		}
	},
	mounted() {
		// 地图坐标
		this.myOptions = {
			show: false,
			scene: {
				center: {
					lat: 31.277013,
					lng: 120.780691,
					alt: 8624,
					heading: 360,
					pitch: -90,
				},
				sceneMode: 1,
			},
		}
	},
	methods: {
		// 绘制轨迹
		setMap(data) {
			let positions = data.map((item) => [item.longitude, item.latitude])
			// this.addGraphicLayer(this.map, positions, data)
			this.addGraphicLayer(Map, positions, data)
		},

		// //控制popUp
		// showPopupChange(e) {
		// 	if (e) {
		// 		roamLine.openPopup();
		// 	} else {
		// 		roamLine.closePopup();
		// 	}
		// },
		// 初始化地图
		onMapload(map) {
			let that = this
			Map = map;
			// 以下为演示代码
			console.log(this.configUrl, "configUrl");
			// 创建entity图层
			const graphicLayer = new that.mars3d.layer.GraphicLayer()
			map.addLayer(graphicLayer)
		},
		addGraphicLayer(map, positions, data) {
						
			// 在layer上绑定监听事件
			graphicLayer.on(mars3d.EventType.click, function (event) {
				console.log("监听layer，单击了矢量对象", event)
			})

			bindLayerPopup() // 在图层上绑定popup,对所有加到这个图层的矢量数据都生效
			// 加一些演示数据
			const graphic = new mars3d.graphic.ModelEntity({
				style: {
				url: "//data.mars3d.cn/gltf/mars/qiche.gltf",
				scale: 0.5,
				minimumPixelSize: 20,

				// 高亮时的样式（默认为鼠标移入，也可以指定type:'click'单击高亮），构造后也可以openHighlight、closeHighlight方法来手动调用
				highlight: {
					type: mars3d.EventType.click,
					silhouette: true,
					silhouetteColor: "#ff0000",
					silhouetteSize: 4
				},

				label: {
					// 不需要文字时，去掉label配置即可
					text: "皖A0001",
					font_size: 16,
					color: "#ffffff",
					outline: true,
					outlineColor: "#000000",
					pixelOffsetY: -20,
					distanceDisplayCondition: true,
					distanceDisplayCondition_far: 50000,
					distanceDisplayCondition_near: 0
				}
				},
				// forwardExtrapolationType: Cesium.ExtrapolationType.NONE,
				attr: { index: '1', remark: "Model示例" }
			})
			graphicLayer.addGraphic(graphic)
			
			// 设置动态位置
			graphicLayer.eachGraphic((graphic) => {
				graphic.addDynamicPosition(data[this.sindex]) // 首次出现的位置
				this.sindex++
			})
			graphicLayer.eachGraphic((graphic) => {
				graphic.addDynamicPosition(data[this.sindex], 20) // 按20秒运动至指定位置
			})

			// 定时更新动态位置（setInterval为演示）
			setInterval(() => {
				graphicLayer.eachGraphic((graphic) => {
					graphic.addDynamicPosition(data[this.sindex], 20)
				})
			}, 20000)
		},
	}
}


function startFly() {
	debugger
	// 启动漫游
	roamLine.start();
	debugger
	// 显示popup
	roamLine.openPopup();
	debugger
	// 显示基本信息，名称、总长、总时间
	roamLineData.td_alltimes = mars3d.Util.formatTime(roamLine.alltimes);
	roamLineData.td_alllength = mars3d.MeasureUtil.formatDistance(roamLine.alllen);
}

// 显示实时坐标和时间
function showRealTimeInfo(params, _alltime) {
	if (params == null) {
		return
	}

	let val = Math.ceil((params.time * 100) / _alltime)
	if (val < 1) {
		val = 1
	}
	if (val > 100) {
		val = 100
	}

	roamLineData.percent = val

	roamLineData.td_jd = params.lng
	roamLineData.td_wd = params.lat
	roamLineData.td_gd = mars3d.MeasureUtil.formatDistance(params.alt)

	roamLineData.td_times = mars3d.Util.formatTime(params.time)
	roamLineData.td_length = mars3d.MeasureUtil.formatDistance(params.len)

	if (params.hbgd) {
		roamLineData.td_dmhb = mars3d.MeasureUtil.formatDistance(params.hbgd)
	} else {
		roamLineData.td_dmhb = "未知"
	}

	if (params.ldgd) {
		roamLineData.td_ldgd = mars3d.MeasureUtil.formatDistance(params.ldgd)
	} else {
		roamLineData.td_ldgd = "未知"
	}
}
</script>

<style lang="scss" scoped>
.trajectory-map {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
</style>